import React from 'react';
import cIf from 'classnames';
import './selected-ticket-label-view.scss';

import { useIFrameResize } from '../../../logic/hooks/utils';
import { WaitSpinner } from '../../../../jsxctl/utilctl';
import { TicketSelectionWarningList } from './ticket-selection-warning-list';
import { Warning } from '../../../logic/models/ticketselectionwarning';
import { FakeCombo } from '../../atoms/fake-combo';
//import TM from 'ts-translate-js';
//const tr = TM.boundTR;

export interface SelectedTicketLabelViewProps {
    loading?: boolean;
    mainText: string;
    otherInfo: string;
    rightText: string;
    warnings: Warning[];
    onClick: () => void;
    onRemoveClick: () => void;
}

export function SelectedTicketLabelView({mainText, otherInfo, rightText, loading, onClick, onRemoveClick, warnings}: SelectedTicketLabelViewProps) {
    useIFrameResize();
    const hasWarningMessages = warnings?.length > 0;

    const warningContent = loading ? <WaitSpinner /> : <TicketSelectionWarningList warnings={warnings} />;

    const handleOnTicketLabelClick = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        if(onClick) onClick();
    };

    const handleOnRemoveTicket = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        onRemoveClick();
    };

    //eslint-disable-next-line jsx-a11y/click-events-have-key-events,sonarjs/mouse-events-a11y
    return <div className={cIf(["selected-ticket-label", {'ticket-warning': hasWarningMessages}])}>
        <div className="ticket-infos">
            <FakeCombo leftText={mainText} rightText={rightText} onClick={handleOnTicketLabelClick}/>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,sonarjs/mouse-events-a11y */}
            <i onClick={handleOnRemoveTicket} className="fas fa-trash-alt"></i>
        </div>
        <div className="other-info">
            <label title={otherInfo}>{otherInfo}</label>
        </div>
        {hasWarningMessages && warningContent}
    </div>;
} 